import { useEffect, useState } from "react"
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { hiabColors } from "theme"
import type { ITrainingReport } from "types/trainingReportTypes"

interface Props {
  trainingReports: Array<ITrainingReport>
}

interface IInstance {
  date: string
  count: number
}

export function TrainingChart({ trainingReports }: Props) {
  const [instances, setInstances] = useState<Array<IInstance>>([])

  useEffect(() => {
    const t = new Date()
    const d = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate() - 30))

    const filteredTrainings = trainingReports.filter((item) => new Date(item.startDate) >= d)

    const tempInstances: Array<IInstance> = []

    for (let i = 0; i < 31; i++) {
      const insta = {
        date: new Date(d.getFullYear(), d.getMonth(), d.getDate() + i).toLocaleDateString("DD-MM"),
        count: 0,
      }
      tempInstances.push(insta)
    }

    filteredTrainings.forEach((x) => {
      const date = new Date(x.startDate).toLocaleDateString("DD-MM")

      const obj = tempInstances.find((x) => x.date === date)

      if (obj) {
        obj.count += 1
      }
    })

    setInstances(tempInstances)
  }, [trainingReports])

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart width={150} height={40} data={instances}>
        <Bar dataKey="count" fill={hiabColors.bluePrimary} name="Trainings" />
        <Tooltip />

        <XAxis dataKey="date" />
        <YAxis />
      </BarChart>
    </ResponsiveContainer>
  )
}
